import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Button } from "@aws-amplify/ui-react";

// TODO: we should keep apiKeys in environment variables
const apiKey = "7wqxxu7wcj39rvgm0s2ep1zhxz0sz4dbcksafa9a0z8xqove";

function TextEditor({
  initialValue,
  onEditorChange,
  editorIndex,
  textFieldCount,
  removeHandler,
}) {
  return (
    <>
      <Editor
        apiKey={apiKey}
        value={initialValue || ""}
        init={{
          min_height: 1200,
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
        onEditorChange={(e) => {
          onEditorChange(editorIndex, e);
        }}
      />
      {textFieldCount > 0 && (
        <Button
          onClick={() => removeHandler(editorIndex)}
          variation="danger"
          size="small"
          color="red"
          style={{ display: "block", margin: "0 auto 20px" }}
        >
          Remove
        </Button>
      )}
    </>
  );
}

export default TextEditor;
